import * as PasswordConstants from './PasswordConstants';

const initialState = {
  loading: false,
  data: [],
  error: null
};

function PasswordReducer(state = initialState, action={}) {
  switch (action.type) {
    case PasswordConstants.CHANGE_PASSWORD_REQUEST:
    case PasswordConstants.VERIFY_PASSWORD_REQUEST:
    case PasswordConstants.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PasswordConstants.CHANGE_PASSWORD_SUCCESS:
    case PasswordConstants.VERIFY_PASSWORD_SUCCESS:
    case PasswordConstants.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case PasswordConstants.CHANGE_PASSWORD_FAILURE:
    case PasswordConstants.VERIFY_PASSWORD_FAILURE:
    case PasswordConstants.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

export default PasswordReducer;